import React, { useEffect } from 'react';
import './App.css';
import { Route, Routes, useNavigate } from 'react-router-dom';
import AddSites from './Routes/Properties/AddSites';
import GlobalAppBar from './GlobalCompos/AppBar';
import ListAllCustomers from './Routes/Client/ListAllCustomers';
import 'antd/dist/antd.min.css';
import Login from './Auth/Login';
import Dashboard from './Routes/Dashboard';
import ScrollToTop from "./ScrollToTop"; // import the component
import AddClientForm from './Routes/Client/AddClients';
import PropertyList from './Routes/Properties/Listsites';
import AddSitesMultiStep from './Routes/Properties/EditProperty';
import DeletedPropertyList from './Routes/Properties/DeletedProperties';
import EmailSender from './Routes/Marketing/Email';
import VisitorCount from './Routes/Analytics/VisitorCount';


function App() {
  const navigate = useNavigate();
  useEffect(() => {
    if (!window.localStorage.getItem("vdcLogin")) {
      navigate("/");
    }
  }, [])

  return (
    <div>
      <ScrollToTop />
      {window.location.pathname !== '/' && <GlobalAppBar />}
      <Routes>
        <Route exact="true" path="/" element={<Login />} />
        <Route exact="true" path="/dashboard" element={<Dashboard />} />
        <Route exact="true" path="/list-properties" element={<PropertyList />} />
        <Route path="/edit/:id" element={<AddSitesMultiStep />} />

        <Route exact="true" path="/list-clients" element={<ListAllCustomers />} />
        <Route exact="true" path="/add-clients" element={<AddClientForm />} />
        <Route exact="true" path="/add-properties" element={<AddSites />} />
        <Route exact="true" path="/deleted-properties" element={<DeletedPropertyList />} />

        {/* MARKETING */}
        <Route exact="true" path="/email-marketing-clients" element={<EmailSender />} />


        {/* VISITORS COUNT */}
        <Route exact="true" path="/visitor-count" element={<VisitorCount />} />



      </Routes>

    </div>
  );
}

export default App;
